import * as React from 'react';
export const MemberHeader = props => {
    return (React.createElement("div", { className: 'w-full bg-light-gray-bg overflow-x-scroll md:overflow-auto' },
        React.createElement("div", { className: 'flex h-12 container w-full content-center p-0' },
            React.createElement("div", { className: 'flex mx-auto  px-2' },
                React.createElement(HeaderLink, { text: 'account', active: props.page === 'account', onClick: () => {
                        window.location.href = '/account';
                    } }),
                React.createElement(Separator, null),
                React.createElement(HeaderLink, { text: 'subscriptions', active: props.page === 'subscription', onClick: () => {
                        window.location.href =
                            '/tools/recurring/login';
                    } }),
                React.createElement(Separator, null),
                React.createElement(HeaderLink, { text: 'faq', active: props.page === 'faq', onClick: () => {
                        window.location.href = '/pages/faq#faq-heading-subscriptions';
                    } }),
                React.createElement(Separator, null),
                React.createElement(HeaderLink, { dataTest: "logout-button", text: 'logout', onClick: () => {
                        window.location.href = '/account/logout';
                    } })))));
};
const Separator = () => React.createElement("div", { className: 'w-3 sm:w-12 h-1' });
const HeaderLink = props => {
    return (React.createElement("div", { className: 'flex flex-col cursor-pointer', "data-test": props.dataTest, onClick: props.onClick },
        React.createElement("div", { className: `flex flex-1 items-center text-navy-blue-500 uppercase font-semibold font-sans text-xs relative ${props.active ? 'top-0.5' : ''}` }, props.text),
        props.active && React.createElement("div", { className: 'w-full h-0.5 bg-navy-blue-500' })));
};
